import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { FiDownload } from 'react-icons/fi'
import moment from 'moment'

import { DateModal } from './date-modal'
import { ap_types, ar_types } from './constants'
import { SearchBar } from '../search-bar'
import { Button } from '../buttons'
// import { Pagination } from '../pagination'
import { FONTS } from '../../constants'

import { accountingAction } from '../../actions'
import { accountingSelector } from '../../selectors'

export const ActionBar = ({ activeTab }) => {
  const access_token = localStorage.getItem('access_token')
  const dispatch = useDispatch()
  const [dateModal, setDateModal] = useState({ isOpen: false })

  const isAP = activeTab === 0

  const apFilter = useSelector(accountingSelector.getAPFilter)
  const apDeliveryStart = apFilter.deliveryStartDate
  const apDeliveryEnd = apFilter.deliveryEndDate
  const apDueStart = apFilter.dueStartDate
  const apDueEnd = apFilter.dueEndDate

  const arFilter = useSelector(accountingSelector.getARFilter)
  const arDueStart = arFilter.dueStartDate
  const arDueEnd = arFilter.dueEndDate

  const billingUrl = useSelector(accountingSelector.getBillingExportURL)
  const payingUrl = useSelector(accountingSelector.getPayingExportURL)

  useEffect(() => {
    if (billingUrl) {
      window.open(billingUrl, '_blank')
      dispatch(accountingAction.resetExportBillings())
    } else if (payingUrl) {
      window.open(payingUrl, '_blank')
      dispatch(accountingAction.resetExportPayings())
    }
  }, [billingUrl, payingUrl])

  const handleSearch = () => {
    const keywordSearch = document.getElementById('keywordSearch')
    dispatch(accountingAction.setKeywordSearch({ keywordSearch: keywordSearch.value }))
  }

  const handleInput = (name, e) => {
    if (isAP) {
      if (name === 'deliveryStartDate' || name === 'deliveryEndDate') {
        dispatch(accountingAction.setAPFilter({
          apFilter: { ...apFilter, [name]: e, dueStartDate: null, dueEndDate: null },
        }))
      } else if (name === 'dueStartDate' || name === 'dueEndDate') {
        dispatch(accountingAction.setAPFilter({
          apFilter: { ...apFilter, [name]: e, deliveryStartDate: null, deliveryEndDate: null },
        }))
      } else {
        dispatch(accountingAction.setAPFilter({ apFilter: { ...apFilter, [name]: e } }))
      }
    } else {
      dispatch(accountingAction.setARFilter({ arFilter: { ...arFilter, [name]: e } }))
    }
  }

  const handleExport = () => {
    if (isAP) {
      dispatch(accountingAction.exportPayings(access_token))
    } else {
      dispatch(accountingAction.exportBillings(access_token))
    }
  }

  const handleDate = (name) => {
    setDateModal({
      name,
      isOpen: true,
    })
  }

  return (
    <Root>
      <DateModal
        dateModal={ dateModal }
        deliveryStartDate={ apDeliveryStart }
        deliveryEndDate={ apDeliveryEnd }
        dueStartDate={ isAP ? apDueStart : arDueStart }
        dueEndDate={ isAP ? apDueEnd : arDueEnd }
        handleInput={ handleInput }
        setDateModal={ setDateModal }
      />
      <Row>
        <SearchBar handleSearch={ handleSearch } />
        <Group>
          { isAP &&
          <DateWrapper>
            <DateButton onClick={ () => handleDate('delivery') }>
              { (apDeliveryStart && apDeliveryEnd)
                ? `${moment(apDeliveryStart).format('DD/MM/YYYY')} - ${moment(apDeliveryEnd).format('DD/MM/YYYY')}`
                : (apDeliveryStart && !apDeliveryEnd
                  ? moment(apDeliveryStart).format('DD/MM/YYYY')
                  : (!apDeliveryStart && apDeliveryEnd
                    ? moment(apDeliveryEnd).format('DD/MM/YYYY')
                    : 'Select Delivery Date'))
              }
            </DateButton>
          </DateWrapper>
          }
          { isAP ?
            <DateWrapper>
              <DateButton onClick={ () => handleDate('due') }>
                { (apDueStart && apDueEnd)
                  ? `${moment(apDueStart).format('DD/MM/YYYY')} - ${moment(apDueEnd).format('DD/MM/YYYY')}`
                  : (apDueStart && !apDueEnd
                    ? moment(apDueStart).format('DD/MM/YYYY')
                    : (!apDueStart && apDueEnd
                      ? moment(apDueEnd).format('DD/MM/YYYY')
                      : 'Select Due Date'))
                }
              </DateButton>
            </DateWrapper>
            :
            <DateWrapper>
              <DateButton onClick={ () => handleDate('due') }>
                { (arDueStart && arDueEnd)
                  ? `${moment(arDueStart).format('DD/MM/YYYY')} - ${moment(arDueEnd).format('DD/MM/YYYY')}`
                  : (arDueStart && !arDueEnd
                    ? moment(arDueStart).format('DD/MM/YYYY')
                    : (!arDueStart && arDueEnd
                      ? moment(arDueEnd).format('DD/MM/YYYY')
                      : 'Select Due Date'))
                }
              </DateButton>
            </DateWrapper>
          }
          {/* <DropdownWrapper>
            <CheckboxSelect
              placeholder='Select LOB'
              value={ lob }
              options={ lobs }
              onChange={ e => handleInput('lob', e) }
            />
          </DropdownWrapper> */}
        </Group>
        <ButtonWrapper>
          <Button
            theme='#428BCA'
            icon={ <FiDownload style={ { fontSize: 16 } } /> }
            width='82px'
            height='26px'
            onClick={ handleExport }
          >
          Export
          </Button>
        </ButtonWrapper>
      </Row>
      <Row>
        <ToggleTabs>
          {(isAP ? ap_types : ar_types).map((t, key) =>
            (<Toggle
              key={ key }
              active={ key === (isAP ? apFilter.status : arFilter.status) }
              onClick={ () => handleInput('status', key) }
            >
              { t.label }
            </Toggle>)
          )}
        </ToggleTabs>
        {/* <Pagination totalItemsCount={ 40 } /> */}
      </Row>
    </Root>
  )
}

const Root = styled.div`
  height: 95px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding: 12px 24px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.078);
`

const Row = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const DateWrapper = styled.div`
  margin-left: 12px;
`

// const DropdownWrapper = styled(DateWrapper)`
//   max-width: 130px;
//   width: 100%;
// `

const ButtonWrapper = styled.div`
  margin-left: 12px;
`

const Group = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`

const ToggleTabs = styled.div`
  display: flex;
  align-items: center;
`

const Toggle = styled.div`
  width: auto;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${p => (p.active ? '#2F80ED' : '#FFFFFF')};
  border: ${p => (p.active ? '1px solid #004AAE;' : '1px solid #F2F2F2;')};
  color: ${p => (p.active ? '#FFFFFF' : '#808080')};
  font-family: ${p => (p.active ? FONTS.GOTHAM_BOLD : FONTS.GOTHAM)};
  font-size: ${FONTS.SMALL_SIZE};
  padding: 8px 12px;
  cursor: pointer;

  :nth-child(1) {
    border-radius: 4px 0px 0px 4px;
  }

  :nth-last-child(1) {
    border-radius: 0px 4px 4px 0px;
  }

  ${p => !p.active && `
    :hover {
      background: rgba(47, 128, 237, 0.16);
      border: 1px solid #004AAE;
      color: #2F80ED;
    }
  `}
`

const DateButton = styled.div`
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
  background: #FFFFFF;
  border: 1px solid #EAEAEA;
  border-radius: 4px;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #333333;
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/components/accounting-dashboard/action-bar.js